// Datos del viaje "Islandia Salvaje" — The W Project
// Editable: cambia aquí fechas, precio, contacto e imágenes.

export const CONTACT = {
  whatsapp: "34660612237",
  whatsappDisplay: "+34 660 612 237",
  email: "hola@comeviajaama.com",
  instagram: "https://instagram.com/comeviajaamaexperiences",
  instagramHandle: "@comeviajaamaexperiences",
  tiktok: "https://www.tiktok.com/@comeviajaama",
  tiktokHandle: "@comeviajaama",
  base: "Guardamar del Segura, Alicante",
};

export const WHATSAPP_MSG =
  "Hola The W Project 👋 Quiero reservar mi plaza para Islandia Salvaje (19–22 marzo 2027). ¿Me contáis?";

export const whatsappUrl = () =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(WHATSAPP_MSG)}`;

export const mailtoUrl = () =>
  `mailto:${CONTACT.email}?subject=${encodeURIComponent(
    "Reserva · Islandia Salvaje (19–22 marzo 2027)"
  )}&body=${encodeURIComponent(WHATSAPP_MSG)}`;

export const TRIP = {
  dates: "19 — 22 Marzo 2027",
  datesShort: "MAR · 2027",
  duration: "4 días / 3 noches",
  seats: "18 plazas",
  price: "1.585",
  currency: "€",
  priceNote: "por persona · experiencia integral incluida",
  departure: "Salida desde Alicante",
  soldout: "Grupos 2026 completos",
};

// Fecha de inicio del próximo grupo y plazas disponibles (editable)
export const TRIP_DATE_ISO = "2027-03-19T00:00:00";
export const SEATS_LEFT = 9;

// Testimonios. El primero es real (dossier). Los marcados SAMPLE son de ejemplo
// con retratos de stock — sustitúyelos por reseñas y fotos reales cuando quieras.
export const TESTIMONIALS = [
  {
    quote:
      "Hay una parte del viaje que te transforma. Vi The W Project y supe que quería formar parte de él; y así me siento ahora después de Islandia: parte de algo único y especial, con una familia nueva.",
    author: "Mª Carmen",
    trip: "Islandia · Marzo 2024",
    photo: "https://images.unsplash.com/photo-1672724702430-c441211caf4c?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    real: true,
  },
  {
    quote:
      "No se parece a ningún viaje que hayas hecho antes. Es una experiencia completamente diferente: volví a casa transformado y con auroras que no olvidaré jamás.",
    author: "Javier",
    trip: "Islandia · Marzo 2024",
    photo: "https://images.unsplash.com/photo-1598966739654-5e9a252d8c32?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
  {
    quote:
      "Rubén cuida cada detalle al milímetro, pero sin perder nunca la capacidad de improvisar. Te sientes en las mejores manos de principio a fin.",
    author: "Laura",
    trip: "Islandia · Noviembre 2024",
    photo: "https://images.unsplash.com/photo-1764773966016-3df06f687be2?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
  {
    quote:
      "Cuando crees que lo has visto todo, siempre te sorprenden con algo más. Cada día guardaba algo inesperado que no esperábamos.",
    author: "Andrés",
    trip: "Islandia · Noviembre 2024",
    photo: "https://images.unsplash.com/photo-1678481645064-16770b99cc80?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
  {
    quote:
      "Conoces al grupo de verdad y sientes que los días son increíblemente largos, en el mejor de los sentidos. Exprimimos cada segundo sin darnos cuenta.",
    author: "Marta",
    trip: "Islandia · Noviembre 2024",
    photo: "https://customer-assets-cm19k8pv.emergentagent.net/job_viaje-islandia/artifacts/rl45p9z5_WhatsApp%20Image%202026-08-13%20at%2011.12.09%20%282%29.jpeg",
  },
  {
    quote:
      "Grupos reducidos, cero turismo de masas y una aventura 100% a medida. Diferente a todo, con un grupo que ya es familia. Repetiré sin dudarlo.",
    author: "Sergio",
    trip: "Islandia · Marzo 2024",
    photo: "https://customer-assets-cm19k8pv.emergentagent.net/job_viaje-islandia/artifacts/8kgvb5zd_WhatsApp%20Image%202026-08-13%20at%2011.12.07.jpeg",
  },
];

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/416da19e-10dd-42ef-b4ca-b24eaaddcfc0/images/9e284ccdf3545cd3dca0e0f03b31a77a9f7e46c6a02d32f53d0a6baaaae893fb.jpeg",
  iceCave: "https://static.prod-images.emergentagent.com/jobs/416da19e-10dd-42ef-b4ca-b24eaaddcfc0/images/4c27671e91be33e8eb3f042a408b46f8018bafba42ec98b860df62ff63889145.jpeg",
  iceCave2: "https://static.prod-images.emergentagent.com/jobs/416da19e-10dd-42ef-b4ca-b24eaaddcfc0/images/3f9afd3b11c26d9b4b7e852925278860371141bb05f9e5ef0b30b6310e6ade8f.jpeg",
  glacier: "https://static.prod-images.emergentagent.com/jobs/416da19e-10dd-42ef-b4ca-b24eaaddcfc0/images/b0dfdea98bfb2cd183e81e34459996b721d6ee1d47776b176225fbe67bd65829.jpeg",
  lamb: "https://static.prod-images.emergentagent.com/jobs/416da19e-10dd-42ef-b4ca-b24eaaddcfc0/images/e0e6c3ca44f6c057b911eb4b3fef31deeb5ed49441e41a76415733e1efb570f7.jpeg",
  lava: "https://static.prod-images.emergentagent.com/jobs/416da19e-10dd-42ef-b4ca-b24eaaddcfc0/images/71095a4a02d1f0af3519e98cd9022a4c3b33b5c64b052b68994751cb04a71994.jpeg",
  van: "https://static.prod-images.emergentagent.com/jobs/416da19e-10dd-42ef-b4ca-b24eaaddcfc0/images/16bd72a45f95032e605548d4248527abe92784d74cd850c420f3e4720b962c42.jpeg",
  blackSand: "https://images.unsplash.com/photo-1500043357865-c6b8827edf10?q=85&fm=jpg&crop=entropy&cs=srgb&w=1600",
  blackSandRock: "https://images.unsplash.com/photo-1531019136844-d1bdacc942b0?q=85&fm=jpg&crop=entropy&cs=srgb&w=1600",
  iceCaveStock: "https://images.unsplash.com/photo-1490143921278-d853145e4977?q=85&fm=jpg&crop=entropy&cs=srgb&w=1600",
  canyon: "https://images.unsplash.com/photo-1503673508983-5f2fbaf1df4d?q=85&fm=jpg&crop=entropy&cs=srgb&w=1600",
  lagoon: "https://images.unsplash.com/photo-1473654729523-203e25dfda10?q=85&fm=jpg&crop=entropy&cs=srgb&w=1600",
  realCave: "https://customer-assets-cm19k8pv.emergentagent.net/job_viaje-islandia/artifacts/gmrqw2v5_WhatsApp%20Image%202026-08-13%20at%2011.12.09%20%281%29.jpeg",
  realBeach: "https://customer-assets-cm19k8pv.emergentagent.net/job_viaje-islandia/artifacts/rl45p9z5_WhatsApp%20Image%202026-08-13%20at%2011.12.09%20%282%29.jpeg",
  realGroup: "https://customer-assets-cm19k8pv.emergentagent.net/job_viaje-islandia/artifacts/8kgvb5zd_WhatsApp%20Image%202026-08-13%20at%2011.12.07.jpeg",
  realBriefing: "https://customer-assets-cm19k8pv.emergentagent.net/job_viaje-islandia/artifacts/b52rq98s_WhatsApp%20Image%202026-08-13%20at%2011.12.09.jpeg",
};

export const LOGO_URL =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_viaje-islandia/artifacts/1llbst3y_Logotipo%20Tarjeta%20The%20W%20Project.png";

export const EXPERIENCE = [
  {
    n: "01",
    title: "Grupo reducido",
    text: "Solo 18 plazas. Nada de turismo de masas: una pequeña familia de viajeros que conduce sus propias 4x4 junto a los líderes de la expedición.",
  },
  {
    n: "02",
    title: "Tierra, fuego, agua & aire",
    text: "Cueva de hielo en Vatnajökull, caminata sobre glaciar con guías expertos e intentos nocturnos de caza de auroras según los partes meteorológicos.",
  },
  {
    n: "03",
    title: "Gastronomía km 0",
    text: "Cenas y almuerzos colaborativos con producto local islandés. Cocinamos juntos, compartimos mesa y dejamos huella en el corazón.",
  },
  {
    n: "04",
    title: "La verdadera #slowlife",
    text: "Sin prisa, respetuosos con el entorno y libres de prejuicios. Activación física matinal y dinámicas para sacar tu mejor versión.",
  },
];

export const ITINERARY = [
  {
    day: "Día 01",
    title: "Nos vamos a Islandia",
    img: IMAGES.van,
    text: "Encuentro en el aeropuerto de Alicante y vuelo a Reikiavik. Recogemos nuestras 4x4, visita breve a la capital y su catedral, y primer contacto con la tierra helada. Noche: tiempo de sueño, sueños y auroras.",
  },
  {
    day: "Día 02",
    title: "Tierra, fuego, agua & aire",
    img: IMAGES.iceCave,
    text: "Rumbo al Parque Nacional Vatnajökull, el mayor glaciar de Europa. Diamond Beach, crampones y ruta sobre el hielo hasta adentrarnos en la cueva de hielo azul. Cena de producto local en Vík.",
  },
  {
    day: "Día 03",
    title: "Exprimiendo el tiempo",
    img: IMAGES.blackSand,
    text: "Círculo Dorado y sur de Islandia: cascadas Seljalandsfoss, Skógafoss y Gullfoss, el área geotérmica de Geysir y Thingvellir. Última cena juntos y planificación para la caza de auroras.",
  },
  {
    day: "Día 04",
    title: "Come, viaja & ama",
    img: IMAGES.glacier,
    text: "Últimos paisajes al amanecer y regreso al aeropuerto. Volvemos a casa distintos a como llegamos, siendo ya parte de algo único y especial.",
  },
];

export const GALLERY = [
  { src: IMAGES.realGroup, alt: "Nuestro grupo en el glaciar · The W Project" },
  { src: IMAGES.iceCave, alt: "Cueva de hielo azul en Vatnajökull" },
  { src: IMAGES.hero, alt: "Aurora boreal sobre paisaje volcánico" },
  { src: IMAGES.realCave, alt: "En la cueva de hielo azul" },
  { src: IMAGES.lava, alt: "Lava fluyendo en un campo volcánico" },
  { src: IMAGES.realBeach, alt: "Come · Viaja · Ama frente al mar de Islandia" },
  { src: IMAGES.lamb, alt: "Cordero islandés, cena de producto local" },
  { src: IMAGES.glacier, alt: "Caminata sobre el glaciar" },
  { src: IMAGES.realBriefing, alt: "Briefing y convivencia antes de la aventura" },
  { src: IMAGES.blackSand, alt: "Playa de arena negra de Reynisfjara" },
  { src: IMAGES.canyon, alt: "Cañón volcánico de Fjaðrárgljúfur" },
  { src: IMAGES.lagoon, alt: "Laguna glaciar de Jökulsárlón" },
];

export const INCLUDES = [
  "Traslados en furgoneta 4x4 con los líderes de la expedición",
  "Guías con conocimiento del destino desde España",
  "Combustible, parkings y accesos a espacios naturales",
  "Cueva de hielo (Blue Ice Cave) y caminata sobre glaciar con guías",
  "Material y guías específicos para la ice cave",
  "Intentos nocturnos de avistamiento de auroras",
  "3 noches en Base Camp único en el sur de Islandia",
  "3 cenas, 3 desayunos y 2 almuerzos colaborativos km 0",
  "Activación física matinal y dinámicas de grupo",
  "Prenda polar técnica personalizada",
  "Material para actividades extremas",
  "Seguro de viaje con asistencia médica y RC",
  "10% de descuento para tu próxima aventura The W Project",
];

export const NOT_INCLUDES = [
  "El vuelo ida/vuelta Alicante – Reikiavik – Alicante. Deberá comprarlo directamente el viajero en la web de la compañía (actualmente ~250 € ida y vuelta).",
  "El traslado ida/vuelta hasta el punto de partida (Aeropuerto de Alicante). Nos coordinaremos por provincias para agruparnos en el menor número de coches posible.",
  "Bebidas alcohólicas y situaciones extraordinarias derivadas de fenómenos meteorológicos adversos, en un país tan imprevisible como Islandia.",
  "Los gastos personales.",
  "La excursión guiada al volcán Grindavík aún no se oferta debido a la inmediatez de su erupción. Valoraremos in situ si es posible aproximarnos al volcán o si deberemos conformarnos con su avistamiento desde las inmediaciones.",
];

export const MARQUEE = [
  "COME",
  "VIAJA",
  "AMA",
  "LA AVENTURA TE ELIGE A TI",
  "#SLOWLIFE",
];
